import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';
import { authHeader, config } from '../../_helpers';

export const Vipr = (props) => {
  const {
    onChange,
    handleSubmit,
    errors = {},
    manifestFormActions,
    handleManifestStartDates,
    handleManifestFinishDates,
    form,
    curDate,
    formatDate,
    crewOptions,
    handleOnViewResourceOrderForm,
    eff_start_date,
    eff_end_date,
    manifestType,
    viewOnly = false,
    printManifest = () => { },
    resource_id,
  } = props;

  const [isLoadingSuperintendent, setIsLoadingSuperintendent] = useState(false);

  useEffect(() => {
    // Get resource_id from prop or form
    const resourceId = resource_id || form?.resource_id || form?.resource_identifier_id;

    // Only fetch if resource_id is available and field is not already populated
    if (resourceId && !form?.sign_auth_representative && !isLoadingSuperintendent) {
      setIsLoadingSuperintendent(true);
      fetch(`${config.apiUrl}/api/getsuperintenddetails?resource_id=${resourceId}`, {
        headers: authHeader(),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success && data.data) {
            // data.data is an array, get the first item
            const superintendent = Array.isArray(data.data) ? data.data[0] : data.data;
            if (superintendent) {
              const { first_name, last_name } = superintendent;
              if (first_name && last_name) {
                const fullName = `${first_name} ${last_name}`.trim();
                // Auto-populate the field using onChange
                onChange({
                  target: {
                    name: 'sign_auth_representative',
                    value: fullName,
                  },
                });
              }
            }
          }
          setIsLoadingSuperintendent(false);
        })
        .catch((error) => {
          setIsLoadingSuperintendent(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resource_id, form?.resource_id, form?.resource_identifier_id, form?.sign_auth_representative]);

  return (
    <div
      id='view_print_manifest'
      className='print_manifest_wrap vipr_manifest_wrapper'
    >
      <h2>{viewOnly ? 'View' : 'Finalize'} Manifest</h2>
      <div className={'effective_date ' + (errors.mdateError ? 'end-date-error' : '')}>
        <span className='from'>
          Manifest Effective dates:
          <div className='manifesttDateWrapper'>
            <DatePicker
              name='start_date'
              placeholderText=''
              dateFormat='MM/DD/YYYY'
              popperPlacement='bottom-end'
              selected={eff_start_date}
              onChange={handleManifestStartDates}
              showMonthDropdown
              showYearDropdown
              dropdownMode='select'
              readOnly={viewOnly}
            />
          </div>
          <span className='to'>To</span>
          <div className='manifesttDateWrapper'>
            <DatePicker
              name='start_date'
              placeholderText=''
              dateFormat='MM/DD/YYYY'
              popperPlacement='bottom-end'
              selected={eff_end_date}
              onChange={handleManifestFinishDates}
              showMonthDropdown
              showYearDropdown
              dropdownMode='select'
              readOnly={viewOnly}
            />
          </div>
        </span>
      </div>
      <form id='form1' onSubmit={handleSubmit}>
        <fieldset disabled={viewOnly}>
          <div id='view_printing_page'>
            <div
              className='responsive_table vipr_view_manifest'
              id='general_information_table'
            >
              <div className='top_table table'>
                <div className='tr order_info'>
                  <div
                    className='td'
                    data-header-title='Ordering office and name of dispatcher (dispatch location)'
                  >
                    <h4>
                      Ordering office and name of <br />
                      dispatcher (dispatch location)
                    </h4>
                    <input
                      type='text'
                      errors={errors.unitError}
                      placeholder='Fill...'
                      id={'orderingUnit' + manifestType}
                      name='ordering_unit'
                      value={form.ordering_unit}
                      onChange={onChange}
                    />
                  </div>
                  <div
                    className='td'
                    data-header-title='Fire name and unit (Destination)'
                  >
                    <h4>Fire name and unit (Destination)</h4>
                    <input
                      type='text'
                      errors={errors.incidentNameError}
                      placeholder='Fill...'
                      id={'incidentName' + manifestType}
                      name='incident_name'
                      value={form.incident_name}
                      onChange={onChange}
                    />
                  </div>
                  <div className='td' data-header-title='Resource order number'>
                    <h4>Resource order number</h4>
                    <input
                      type='text'
                      errors={errors.resourceError}
                      placeholder='Fill...'
                      id={'resourceNumber' + manifestType}
                      name='resource_number'
                      value={form.resource_number}
                      onChange={onChange}
                    />
                  </div>
                </div>
              </div>

              <div className='top_table no_border table'>
                <div className='tr contractor_info'>
                  <div className='td' data-header-title='Name of contractor'>
                    <h4>Name of contractor</h4>
                    <p id='sup_det_create'>
                      {config.companyNameFull}
                    </p>
                  </div>
                  <div className='td' data-header-title='Unique vehicle number'>
                    <h4>Unique vehicle number</h4>
                    <input
                      type='text'
                      errors={errors.vehNumError}
                      placeholder='Fill...'
                      id='uniqVehNumber4'
                      name='vehicle_number'
                      value={form.vehicle_number}
                      onChange={onChange}
                    />
                  </div>
                  <div className='td' data-header-title='Aggrement Number'>
                    <h4>Aggrement Number</h4>
                    <input
                      type='text'
                      errors={errors.ifcaError}
                      placeholder='Fill...'
                      id={'ifcaNumber' + manifestType}
                      name='ifca_number'
                      value={form.ifca_number}
                      onChange={onChange}
                    />
                  </div>
                </div>
                <div className='tr location'>
                  <div
                    className='td'
                    data-header-title='Time of departure (dispatch location)'
                  >
                    <h4>
                      Time of departure (dispatch <br />
                      location):
                    </h4>
                    <input
                      type='text'
                      errors={errors.dispatchTimeError}
                      placeholder='Fill...'
                      id='dispatchTime4'
                      name='dispatch_time'
                      value={form.dispatch_time}
                      onChange={onChange}
                    />
                  </div>
                  <div
                    className='td'
                    data-header-title='Time of arrival to (final destination)'
                  >
                    <h4>
                      Time of arrival to (final <br />
                      destination):
                    </h4>
                    <input
                      type='text'
                      errors={errors.reportToError}
                      placeholder='Fill...'
                      id='reportTo4'
                      name='report_to'
                      value={form.report_to}
                      onChange={onChange}
                    />
                  </div>
                  <div
                    className='td'
                    data-header-title='Do you have the personnel to rotate crews?'
                  >
                    <h4>
                      Do you have the personnel to <br />
                      rotate crews?
                    </h4>

                    <select
                      className='perssonal'
                      name='perssonal'
                      value={form.perssonal}
                      onChange={onChange}
                    >
                      <option value='Y'>Y</option>
                      <option value='N'>N</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className='top_table no_border place table'>
                <div className='tr'>
                  <div className='print_center no_padding_border td'>
                    <div className='top_table no_border table place1'>
                      <div className='tr'>
                        <div
                          className='print_center td_height td'
                          data-header-title='INTERMEDIATE STOPS (PLACE)'
                        >
                          <h5>INTERMEDIATE STOPS (PLACE)</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.interSpaceError}
                              placeholder='Fill...'
                              id='interSpace4'
                              name='inter_space'
                              value={form.inter_space}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                        <div
                          className='print_center td_height td'
                          data-header-title='ARR TIME'
                        >
                          <h5>
                            ARR <br />
                            TIME
                          </h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.arrError}
                              placeholder='Fill...'
                              id='arr4'
                              name='arr'
                              value={form.arr}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='print_center no_padding_border td'
                    width='23%'
                  >
                    <div className='top_table no_border table place2'>
                      <div className='tr'>
                        <div
                          className='print_center td_height td'
                          data-header-title='DEP TIME'
                        >
                          <h5>
                            DEP <br />
                            TIME
                          </h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.depTimeError}
                              placeholder='Fill...'
                              id='depTime4'
                              name='dep_time'
                              value={form.dep_time}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                        <div
                          className='print_center td_height td'
                          data-header-title='PLACE'
                        >
                          <h5>PLACE</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.depPlaceError}
                              placeholder='Fill...'
                              id='depPlace4'
                              name='dep_place'
                              value={form.dep_place}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                        <div
                          className='print_center td_height td'
                          data-header-title='ARR TIME'
                        >
                          <h5>
                            ARR <br />
                            TIME
                          </h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.depArrError}
                              placeholder='Fill...'
                              id='depArr4'
                              name='dep_arr'
                              value={form.dep_arr}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='print_center no_padding_border td'>
                    <div className='top_table no_border table place3'>
                      <div className='tr'>
                        <div
                          className='print_center td_height td'
                          colSpan='3'
                          data-header-title='DEP TIME'
                        >
                          <h5>
                            DEP <br />
                            TIME
                          </h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.perDepTimeError}
                              placeholder='Fill...'
                              id='perDepTime4'
                              name='pdep_time'
                              value={form.pdep_time}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                        <div
                          className='print_center td_height td'
                          colSpan='3'
                          data-header-title='PLACE'
                        >
                          <h5>PLACE</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.perDepPlaceError}
                              placeholder='Fill...'
                              id='perDepPlace4'
                              name='pedep_place'
                              value={form.pedep_place}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='responsive_table'>
              <div
                className='table top_table table_space vipr_employee_details'
                id='view_employee_details_table'
              >
                <p className='mobile_crew'>Employee Details</p>
                <div className='thead'>
                  <div className='tr'>
                    <div className='print_center th'>
                      <h4>Employee Name</h4>
                    </div>
                    <div className='print_center gender th'>
                      <h4>M</h4>
                    </div>
                    <div className='print_center gender th'>
                      <h4>F</h4>
                    </div>
                    <div className='print_center th'>
                      <h4>Position</h4>
                    </div>
                    <div className='print_center th'>
                      <h4>
                        LAST NIGHT NOT SPENT
                        <br /> ON FIRE ASSIGNMENT
                        <br /> (DATE)
                      </h4>
                    </div>
                    <div className='print_center th'>
                      <h4>
                        UNIQUE EMPLOYEE <br />
                        NUMBER <br />
                        (NO SSN)
                      </h4>
                    </div>
                  </div>
                </div>
                <div className='tbody'>{crewOptions}</div>
              </div>
            </div>
            <div className='top_table no_border vipr_sign signature table'>
              <div className='tbody'>
                <div className='tr'>
                  <div width='74.3%' className='td'>
                    <h4 className='title_bottom'>
                      SIGNATURE OF AUTHORIZED REPRESENTATIVE
                    </h4>
                    <p>
                      <input
                        type='text'
                        placeholder='Fill...'
                        id='sign4'
                        errors={errors.signError}
                        name='sign_auth_representative'
                        value={form.sign_auth_representative}
                        onChange={onChange}
                        readOnly
                      />
                    </p>
                  </div>
                  <div className='td'>
                    <h4>DATE</h4>
                    <span className='print_date'>{formatDate(curDate)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='clearFix' />
          {manifestFormActions}
        </fieldset>
        {viewOnly && (
          <div className='gear-option-btn-wrap'>
            <input
              type='button'
              id='to_view_final_print'
              className={`button save_manifest`}
              name='print'
              onClick={printManifest}
              value='Print Manifest'
            />
            {form.resource_order_form && (
              <input
                type='button'
                id='view_ROF'
                onClick={() => handleOnViewResourceOrderForm()}
                value='View RO'
                name='view_ROF'
                className={`button save_manifest}`}
              />
            )}
          </div>
        )}
      </form>
    </div>
  );
};

Vipr.propTypes = {
  onChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object,
  handleManifestStartDates: PropTypes.func.isRequired,
  handleManifestFinishDates: PropTypes.func.isRequired,
  form: PropTypes.shape({
    ordering_unit: PropTypes.string,
    incident_name: PropTypes.string,
    resource_number: PropTypes.string,
    vehicle_number: PropTypes.string,
    ifca_number: PropTypes.string,
    dispatch_time: PropTypes.string,
    report_to: PropTypes.string,
    perssonal: PropTypes.string,
    inter_space: PropTypes.string,
    arr: PropTypes.string,
    dep_time: PropTypes.string,
    dep_place: PropTypes.string,
    dep_arr: PropTypes.string,
    pdep_time: PropTypes.string,
    pedep_place: PropTypes.string,
    sign_auth_representative: PropTypes.string,
    resource_order_form: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.shape({
        resource_order_form_type: PropTypes.number,
      }),
    ]),
  }).isRequired,
  curDate: PropTypes.any,
  formatDate: PropTypes.func.isRequired,
  crewOptions: PropTypes.node,
  handleOnViewResourceOrderForm: PropTypes.func.isRequired,
  eff_start_date: PropTypes.instanceOf(Date),
  eff_end_date: PropTypes.instanceOf(Date),
  manifestType: PropTypes.string,
  viewOnly: PropTypes.bool,
  printManifest: PropTypes.func,
  manifestFormActions: PropTypes.node,
};